import Button from '~/components/buttons/Button'
import PopupMenu from '~/components/PopupMenu'
import { useFeatureFlag } from '~/core/featureFlags'

interface SelectionBarProps {
  selectedCount: number
  totalPlatesCount?: number // Add total plates count to know if there are any plates
  onExport?: () => void
  onExportPicklist?: () => void
  onCancel?: () => void
}

export default function SelectionBar({
  selectedCount,
  totalPlatesCount,
  onExport,
  onExportPicklist,
  onCancel,
}: SelectionBarProps) {
  // Don't return null when selectedCount is 0 - show the bar always in selection mode
  const exportHamiltonPicklist = useFeatureFlag('exportQBIHamiltonPicklist')

  // Disable actions when there are no plates available or no plates selected
  const hasNoPlates = (totalPlatesCount ?? 0) === 0
  const hasNoSelection = selectedCount === 0
  const shouldDisableActions = hasNoPlates || hasNoSelection

  const actionOptions = [
    {
      label: 'Bulk Export Culture Metadata',
      action: onExport,
      // Disable when no callback, no plates available, or no plates selected
      disabled: !onExport || shouldDisableActions,
    },
    exportHamiltonPicklist
      ? {
          label: 'Export Picklist',
          action: onExportPicklist,
          // Disable when no callback, no plates available, or no plates selected
          disabled: !onExportPicklist || shouldDisableActions,
        }
      : null,
  ].filter(Boolean)

  return (
    <div className='flex items-center justify-between px-10 py-2.5  border-b border-gray-200'>
      <div className='flex items-center gap-4'>
        <span className='text-gray-700 font-subtext'>
          {selectedCount} {selectedCount === 1 ? 'plate' : 'plates'} selected
        </span>
        <div className='flex items-center gap-3'>
          <PopupMenu
            minimal
            options={actionOptions}
            trigger={
              <Button
                label='Perform action'
                className='cursor-pointer text-grey-dark!'
                disabled={shouldDisableActions}
              />
            }
          />
        </div>
      </div>
      <div className='w-[400px] flex justify-start'>
        <Button label='Cancel' type='danger' onClick={onCancel} />
      </div>
    </div>
  )
}
